import { combineReducers, createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { usersReducer } from './reducers/users';

const rootReducers = combineReducers({
  users: usersReducer
});

export const store = createStore(rootReducers, composeWithDevTools(applyMiddleware(thunk)));
